import { Component, Input, OnInit } from '@angular/core';
import { Toro } from '../../api/common/enumerations';

@Component({
    selector: 'app-document-viewer',
    templateUrl: './document-viewer.component.html',
    styleUrls: ['./document-viewer.component.less']
})
export class DocumentViewerComponent implements OnInit
{
    DocumentType = Toro.DocumentType;

    @Input() documentType: Toro.DocumentType;
    @Input() data: any;
    @Input() enforceMaxWidth = true;

    constructor()
    {
    }

    ngOnInit()
    {
        // if (this.documentType === Toro.DocumentType.Configuration)
        // {
        //     this.enforceMaxWidth = false;
        // }
    }
}
